import { autoinject, transient, BindingEngine } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { ManageVesselService } from "../../../../../services/vessels/manage-vessel.service";
import { VesselThirdPartyInspectionClientModel } from "../../../../../models/vessels/vessel.models";
import { UnitOfWorkObserver } from "../../../../../utilities/unit-of-work-observer";
import { ValidationController, ValidationRules } from "aurelia-validation";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { CustomValidationRenderer } from "../../../../../client-validation-system/custom-validation-renderer";
import { ValidationsClientService } from "../../../../../services/validations/validations-client.service";

@autoinject
@transient()
export class AddThirdPartyInspectionDialog {

    public thirdPartyInspection: VesselThirdPartyInspectionClientModel = null;
    private vesselId: number;
    private id: number;
    private onComplete: (item: VesselThirdPartyInspectionClientModel, action: number) => void;

    private uow: UnitOfWorkObserver;

    constructor(private vesselSerive: ManageVesselService,
        private dialogClientService: DialogClientService,
        private bindingEngine: BindingEngine,
        private validationController: ValidationController,
        private notificationClientService: NotificationClientService,
        private validationsClientService: ValidationsClientService) {
        this.validationController.addRenderer(new CustomValidationRenderer());
    }

    protected activate(model: { onComplete: (item: VesselThirdPartyInspectionClientModel, action: number) => void, id: number, vesselId: number }) {
        this.id = model.id;
        this.vesselId = model.vesselId;
        this.onComplete = model.onComplete;
        if (this.id && this.id > 0)
            this.getItem(this.id);
        else this.initializeNew();
    }

    private getItem(id: number) {
        this.vesselSerive.getThirdPartyInspection(id).then(x => {
            this.thirdPartyInspection = x;

            this.uow = new UnitOfWorkObserver(this.bindingEngine, this.thirdPartyInspection);

            this.uow.startTracking();

            this.addValidationRules();
        });
    }

    private initializeNew() {
        const item: VesselThirdPartyInspectionClientModel = {
            vesselId: null,
            thirdPartyInspectionTypeId: null,
            inspectingCompanyId: null,
            inspectionDate: null,
            vesselOperationAtTimeOfInspectionId: null,
            productBeingHandled: null,
            satisfactoryWithOperatorComments: null,
            comments: null
        };

        this.thirdPartyInspection = item;

        this.uow = new UnitOfWorkObserver(this.bindingEngine, this.thirdPartyInspection);

        this.uow.startTracking();

        this.addValidationRules();

        setTimeout(() => {
            this.thirdPartyInspection.vesselId = Number(this.vesselId);
            this.thirdPartyInspection.inspectionDate = new Date();
        });
    }

    private addValidationRules() {
        ValidationRules
            .ensure<VesselThirdPartyInspectionClientModel, any>(x => x.inspectionDate)
            .displayName('Date of Inspection')
            .required()
            .ensure(x => x.inspectingCompanyId)
            .displayName('Inspecting Company')
            .required()
            .ensure(x => x.thirdPartyInspectionTypeId)
            .displayName('Inspection Type')
            .required()
            .on(this.thirdPartyInspection);
    }

    public async save() {
        const validationResponse = await this.validationController.validate();
        if (validationResponse.valid) {
            try {
                const response = await this.vesselSerive.saveThirdPartyInspection({
                    changes: this.uow.getChanges(),
                    id: this.id
                });
                if (response.validationResult && response.validationResult.hasError) {
                    this.validationsClientService.showValidationErrors(response.validationResult);
                } else {
                    if (this.onComplete) {
                        this.onComplete(response.item, response.action);
                    }
                    this.dialogClientService.hide();
                }
            } catch (exception) {
                if (exception.validationResult && exception.validationResult.hasError) {
                    this.validationsClientService.showValidationErrors(exception.validationResult);
                }
            }

        } else {
            this.notificationClientService.show("Validation Error", validationResponse.results.map(x => x.message).join("<br>"), NotificationType.Error);
        }
    }

    cancel() {
        this.dialogClientService.hide();
    }

    public detached() {
        if (this.uow) {
            this.uow.dispose();
            this.uow = null;
        }
    }
}